import React, { useState, useEffect } from 'react';

// material-ui
import { Box, Button, Grid, InputAdornment, OutlinedInput } from '@mui/material';
import { IconSearch } from '@tabler/icons';
import AddIcon from '@mui/icons-material/Add';

// project imports
import BoardList from './BoardList';
import MainCard from 'ui-component/cards/MainCard';
import { gridSpacing } from 'store/constant';
import PaginationRows from 'ui-component/extended/PaginationRows';
import AddBoard from './AddBoard';
import useApi from 'hooks/useApi';
import VenueService from 'services/VenueService';

const Board = () => {

    const [open, setOpen] = useState(false);
    const [rows, setRows] = useState([]);
    const [reload, setReload] = useState(false);
    const [selectedBoard, setSelectedBoard] = useState(null);
    const [total, setTotal] = useState(1);
    const [page, setPage] = useState(1);
    const [searchText, setSearchText] = useState('');
    const [limit, setLimit] = useState(10);

    const handleClickOpen = (boardUuid) => {
        if (boardUuid) {
            getBoardByUuidApi.execute(boardUuid);
        } else {
            setOpen(true);
        }
    };

    const changeSearch = (e) => {
        setSearchText(e.target.value);
        setPage(1);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedBoard(null);
    };

    const getBoardListHandler = (response) => {
        const data = response.data;
        setRows(data.rows);
        setTotal(data.filtered);
    };

    const getBoardHandler = (response) => {
        setSelectedBoard(response.data);
        setOpen(true);
    };

    const getBoardListApi = useApi(VenueService.getBoardList, getBoardListHandler);
    const getBoardByUuidApi = useApi(VenueService.getBoardByUuid, getBoardHandler);

    useEffect(() => {
        getBoardListApi.execute({
            limit,
            skip: (page * limit) - limit,
            searchValue: searchText.trim()
        });
    }, [searchText, page, limit, reload]);

    return (
        <Box sx={{ width: '100%', typography: 'body1' }}>
            <MainCard
                title={
                    <Grid container alignItems="center" justifyContent="space-between" spacing={gridSpacing}>
                        <Grid item xs={12} md={3}>
                            <Box>
                                <OutlinedInput
                                    id="input-search-list-style1"
                                    placeholder="Search board id, name..."
                                    fullWidth
                                    sx={{ maxWidth: '300px' }}
                                    value={searchText}
                                    onChange={changeSearch}
                                    startAdornment={
                                        <InputAdornment position="start">
                                            <IconSearch stroke={1.5} size="16px" />
                                        </InputAdornment>
                                    }
                                    size="small"
                                />
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={9}>
                            <Grid
                                container
                                justifyContent={{ xs: 'flex-start', md: 'flex-end' }}
                                alignItems="center"
                                spacing={gridSpacing}
                            >
                                <Grid item>
                                    <Button
                                        startIcon={<AddIcon />}
                                        variant="contained"
                                        color="secondary"
                                        onClick={() => handleClickOpen()}
                                    >
                                        Add New Board
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                }
                content={false}
            >
                <BoardList rows={rows} setReload={setReload} handleClickOpen={handleClickOpen} page={page} limit={limit} />
                <PaginationRows
                    total={total}
                    page={page}
                    setPage={setPage}
                    limit={limit}
                    setLimit={setLimit}
                    limits={[10, 15, 20]}
                />
            </MainCard>
            <AddBoard selectedBoard={selectedBoard} open={open} handleClose={handleClose} setReload={setReload} />
        </Box>
    );
};

export default Board;
